import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'price',
      label: i18n.t('labor.unit_value_dollarsign'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Formatter.formatNumber(Number(row[column.property]));
      },
    },
    {
      prop: 'activity.activity_unit_payment.name',
      label: i18n.t('labor.unit'),
      minWidth: 120,
      sortable: true,
      formatter: (row) => {
        return `${row.activity ? row.activity.activity_unit_payment.name : ''}
        (${row.activity ? row.activity.activity_unit_payment.abbreviation : ''})`;
      },
    },
    {
      prop: 'start_date',
      label: i18n.t('common_words.starting_date_f'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },

    {
      prop: 'extra_hours',
      label: i18n.t('labor.hours_extra'),
      minWidth: 120,
      sortable: true,
      align: 'center',
      formatter: (row, column) => {
        return Number(row[column.property]) === 0 ? 'No' : 'Si';
      },
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};
export default configTable